































































































































































// Core
import {Component, Mixins, PropSync} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {parse, format} from 'date-fns'

// Mixins
import GetStoreMixin from '@/mixins/GetStore'

// Types
import {TeamActions} from '@/store/team/types'
import {UsersActions} from '@/store/users/types'

// Store
import {documentsNamespace} from '@store/documents'
import {commonNamespace} from '@/store/common'
import {userNamespace} from '@/store/user'

// Interfaces
import {ElForm} from 'element-ui/types/form'
import {IDocumentTypes} from '@store/documents/Interface'
import {IMark} from '@/store/common/Interface'
import {Order} from '@/store/team/interfaces'
import {Project} from '@/store/projects/interfaces'
import {LegalPerson, UsersState} from '@/store/users/interfaces'
import {RequestParams} from '@/store/interfaces'

// Modules
const NSTeam = namespace('teamModule')
const NSUsers = namespace('usersModule')

@Component({
  name: 'DialogSearchSpecialist',
})
export default class DialogSearchSpecialistComponent extends Mixins(GetStoreMixin) {
  @PropSync('visible', Boolean) private _visible!: boolean

  @NSUsers.State((state: UsersState) => state.legals)
  private legalPersons!: LegalPerson[]

  @NSUsers.Action(UsersActions.A_FETCH_BY_ROLES_LEGAL_PERSONS)
  private fetchLegalPersons!: (params?: RequestParams) => Promise<LegalPerson[]>

  @documentsNamespace.State('documentTypes')
  private documentTypes!: IDocumentTypes[]

  @commonNamespace.State('marks')
  private marks!: IMark[]

  @userNamespace.Getter('project')
  private project!: Project

  @NSTeam.Action(TeamActions.A_CREATE_ORDER)
  private createOrder!: (order: Order) => Promise<Order>

  private form: Order = {
    title: '',
    projectId: 0,
    documentTypeId: null,
    description: '',
    completionDate: '',
    orderPlacementDate: '',
    markIds: [],
  }

  protected rules: any = {
    title: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
    documentTypeId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
    markIds: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
    description: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
    completionDate: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
    orderPlacementDate: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
  }

  protected pickerOptions = {
    disabledDate: time => {
      return time.getTime() > new Date(this.form.completionDate)
    },
  }

  protected created() {
    this.form.projectId = this.selectedProject
    this.fetchLegalPersons({projectId: this.project.id})
  }

  private handleFillTemplate() {
    this.form.description = `${this.getDocument()} для видов работ ${this.getWorks()} по проекту «${this.project.name}»
Срок выполнения работы: ${this.formatDate(this.form.completionDate)}
Адрес объекта: ${this.project.address}.
Заказчик проекта: ${this.legalPersons[0]?.name ?? ''}
Проектировщик: ${this.legalPersons[3]?.name ?? ''}
Сроки проекта: ${this.project.endDate}`
  }

  private getDocument(): string {
    if (this.form.documentTypeId) {
      return this.documentTypes.filter(d => d.id === this.form.documentTypeId)[0].name
    } else {
      return ''
    }
  }

  private getWorks(): string {
    if (this.form.markIds.length) {
      return this.marks
        .filter(m => this.form.markIds.includes(m.id as number))
        .map(m => `${m.description}, (${m.name})`)
        .join(', ')
    } else {
      return ''
    }
  }

  private handleSearchSpecialist() {
    const form = this.$refs.form as ElForm

    form.validate(isValid => {
      if (isValid) {
        this.createOrder(this.form)
          .then(() => {
            this.$notify({
              title: 'Выполнено',
              message: 'Действие успешно выполнено',
              type: 'success',
            })

            this._visible = false

            form.resetFields()
          })
          .catch(error => {
            this.$notify.error({
              title: 'Ошибка',
              message: error.response.data.message,
            })
          })
      }
    })
  }

  private formatDate(date: string): string {
    if (date) {
      const dateFns = parse(date, 'yyyy-MM-dd', new Date())

      return format(dateFns, 'dd.MM.yyyy')
    } else {
      return ''
    }
  }
}
